import { Quote, Star } from "lucide-react";
import Reveal, { SectionLabel } from "../components/Reveal";
import PageHero from "../components/PageHero";
import { SUCCESS_STORIES, TESTIMONIALS } from "../lib/site";

export default function SuccessStories() {
  return (
    <>
      <PageHero
        label="Success Stories"
        title={<>Voices we have <em className="font-italic-accent italic gold-text">helped shape</em>.</>}
        subtitle="Every transformation tells a story. Here are a few of the students whose journeys we are honoured to have walked beside."
      />

      <section data-testid="transformations" className="py-24 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <SectionLabel>Student Transformations</SectionLabel>
            <h2 className="mt-5 font-serif text-3xl lg:text-4xl text-white font-medium uppercase tracking-wide leading-tight">From quiet to commanding</h2>
          </Reveal>

          <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {SUCCESS_STORIES.map((s, i) => (
              <Reveal key={s.name} delay={i * 0.08}>
                <article data-testid={`story-${i}`} className="lux-card overflow-hidden h-full flex flex-col">
                  <div className="relative aspect-[4/3] overflow-hidden">
                    <img src={s.image} alt={s.name} className="absolute inset-0 w-full h-full object-cover grayscale-[20%]" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
                    <div className="absolute bottom-5 left-5">
                      <div className="section-label">{s.program}</div>
                      <h3 className="mt-2 font-serif text-2xl text-white font-medium uppercase tracking-wide">{s.name}</h3>
                    </div>
                  </div>
                  <div className="p-7 flex-1 flex flex-col">
                    <Quote size={22} className="text-[#d4af37]" />
                    <p className="mt-4 font-italic-accent italic text-lg text-white/85 leading-snug">"{s.quote}"</p>
                    <div className="mt-auto pt-5 flex gap-1">
                      {[1,2,3,4,5].map((n) => <Star key={n} size={14} className="fill-[#d4af37] text-[#d4af37]" />)}
                    </div>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 lg:py-28 bg-[#080808] border-y border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <div className="flex justify-center"><SectionLabel>Parent Testimonials</SectionLabel></div>
            <h2 className="mt-5 font-serif text-3xl lg:text-4xl text-white font-medium uppercase tracking-wide leading-tight text-center">The words of families</h2>
          </Reveal>
          <div className="mt-14 grid md:grid-cols-2 gap-6 lg:gap-8">
            {TESTIMONIALS.map((t, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <figure className="lux-card p-9 h-full">
                  <Quote size={26} className="text-[#d4af37]" />
                  <blockquote className="mt-5 font-italic-accent italic text-xl lg:text-2xl text-white/90 leading-snug">"{t.quote}"</blockquote>
                  <figcaption className="mt-7 flex items-center gap-4">
                    <div className="h-10 w-10 grid place-items-center hairline font-serif text-sm text-[#d4af37]">{t.name.split(" ").map((p) => p[0]).join("")}</div>
                    <div>
                      <div className="font-sans text-sm text-white">{t.name}</div>
                      <div className="font-sans text-xs text-white/45">{t.role}</div>
                    </div>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid sm:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {[["150+","Lives Transformed"],["20+","Awards & Recognitions"],["100%","Parent Satisfaction"]].map(([n,l]) => (
            <div key={l} className="bg-[#0a0a0a] px-6 py-9 text-center">
              <div className="font-serif text-4xl gold-text">{n}</div>
              <div className="mt-3 section-label">{l}</div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
